import * as types from '../mutation-types';

const state = {

    cloudHost: '',

    willShow: true,

    topInfo: {

        type: '',
        msgIndex: ''

    }

};

const mutations = {

    [ types.SETTOPINFO ] ( state, topInfo ) {
        
        state.topInfo = topInfo;

    },

    [ types.SETCLOUDHOST ] ( state, cloudHost ) {
        
        state.cloudHost = cloudHost;

    },

    [ types.CLOSETOPINFO ] ( state ) {

        state.topInfo = {

            type: '',
            msgIndex: ''

        };

    },

    [ types.OPENWILLSHOW ] ( state ) {
        
        state.willShow = true;

    },

    [ types.CLOSEWILLSHOW ] ( state ) {
        
        state.willShow = false;

    }

};

const getters = {

    topInfo: state => state.topInfo,
    cloudHost: state => state.cloudHost

};

export default {

    state,
    mutations,
    getters

};



// WEBPACK FOOTER //
// ./src/store/modules/topInfo.js